module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-6.fc6878df.jpg";